import { inject } from '@angular/core';
import { Routes, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';

import { MetricsDashboardComponent } from './home/metrics-dashboard/metrics-dashboard.component';
import { AccountsListComponent } from './tools/accounts-list/accounts-list.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { AuthenticationService } from 'projects/internal/r1-component-library/src/lib/services/appcloud';

export function isAuthorizedGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const authService = inject(AuthenticationService);
        const router = inject(Router);
        const url: string = state.url;

        const isAuthorized = authService.isAuthorized();
        if (isAuthorized) {
            return true;
        }
        authService.redirectUrl = url;
        return router.parseUrl('/login');
    };
}

export function isLoggedInGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const authService = inject(AuthenticationService);
        const router = inject(Router);
        const url: string = state.url;

        const isLoggedIn = authService.isAuthenticated();
        if (isLoggedIn) {
            return true;
        }
        authService.redirectUrl = url;
        return router.parseUrl('/login');
    };
}

export const ADMIN_ROUTES: Routes = [
    { path: 'metrics', component: MetricsDashboardComponent },
    {
        path: 'tools',
        children: [{ path: 'accounts', component: AccountsListComponent }],
    },
    {
        path: '**',
        component: NotFoundComponent,
    },
];
